export enum ArticleLoadingTags {
    Translation,
}
